/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         30/04/24 - 09:54:30
 * Module name:  headers-groups-table.const
 * File name:    headers-groups-table.const.ts
 * IDE:          WebStorm
 */

import {TableColumnAlignEnum, TableColumnEnum, TableColumnInterface, TableIconEnum} from '@shared/components/table';

/**
 * @description
 * User feature tooltips array
 */
export const USERS_FEATURES_TOOLTIPS: string[] =[
  'app.setting.user.create.tab.feature.fields.bi.label', 'app.setting.user.create.tab.feature.fields.op.label','app.setting.user.create.tab.feature.fields.ml.label'
];

/**
 * @description
 * User roles array
 */
export const USERS_ROLES: string[] = [
  'app.shared.session.level.superUser',
  'app.shared.session.level.staff',
  'app.shared.session.level.superAdmin',
  'app.shared.session.level.admin',
  'app.shared.session.level.supervisor',
  'app.shared.session.level.operator',
  'app.shared.session.level.guest',
];

/**
 * User header array
 */
export const USERS_HEADERS: TableColumnInterface[] = [
  {
    field: 'first_name',
    type: TableColumnEnum.textDual,
    header: 'app.setting.user.fields.name.header',
    align: TableColumnAlignEnum.center,
    sort: true,
    dualField: ['first_name', 'last_name'],
    grow: 2
  },
  {
    field: 'level',
    type: TableColumnEnum.enum,
    header: 'app.setting.user.fields.role',
    align: TableColumnAlignEnum.center,
    enumList: ['']
  },
  {
    field: 'email',
    type: TableColumnEnum.text,
    header: 'app.setting.user.fields.email.header',
    align: TableColumnAlignEnum.center,
    grow: 2
  },
  {
    field: 'bi',
    type: TableColumnEnum.iconGroup,
    header: 'app.setting.user.fields.feature.header',
    align: TableColumnAlignEnum.center,
    groupIcon: [TableIconEnum.brain, TableIconEnum.houseLap, TableIconEnum.chartLineUp],
    groupIconFields: ['bi', 'ml', 'op'],
    groupIconTooltips: USERS_FEATURES_TOOLTIPS,
  },
  {
    field: 'is_active',
    type: TableColumnEnum.tag,
    header: 'app.setting.user.fields.status.header',
    align: TableColumnAlignEnum.center,
  }
];
